"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunkT4T7FGFZcjs = require('./chunk-T4T7FGFZ.cjs');


var _chunkQXALS2QCcjs = require('./chunk-QXALS2QC.cjs');

// src/contracts/farm/v1/index.ts
var FARM = {
  NftItem: _chunkT4T7FGFZcjs.FarmNftItemV1,
  NftMinter: _chunkQXALS2QCcjs.FarmNftMinterV1
};



exports.FARM = FARM;
//# sourceMappingURL=chunk-QQGUWBEM.cjs.map